import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import '../style/header.css';

function TransparentNavbar() {
    return (
        <Navbar expand="lg" className="bb-navbar">
            <Container>
                <Navbar.Brand as={Link} to="/" className="bb-brand">
                    <img
                        src={`${process.env.PUBLIC_URL}/logo.png`}
                        width="46"
                        height="46"
                        className="bb-brand__logo"
                        alt="Logo Boubou Studio"
                    />
                    <span className="bb-brand__name bb-display">Boubou Studio</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="bb-nav" className="bb-navbar__toggle" />
                <Navbar.Collapse id="bb-nav">
                    <Nav className="ms-auto">
                        <Nav.Link as={Link} to="/mon-compte" className="bb-account">
                            <FontAwesomeIcon icon={faUserCircle} />
                            Mon compte
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default TransparentNavbar;
